import { render, staticRenderFns } from "./MunicipiosNaMeta.vue?vue&type=template&id=70d449fc&scoped=true"
import script from "./MunicipiosNaMeta.vue?vue&type=script&lang=js"
export * from "./MunicipiosNaMeta.vue?vue&type=script&lang=js"
import style0 from "./MunicipiosNaMeta.vue?vue&type=style&index=0&id=70d449fc&prod&lang=css"
import style1 from "./MunicipiosNaMeta.vue?vue&type=style&index=1&id=70d449fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d449fc",
  null
  
)

export default component.exports